import { FormControl, InputLabel, Select, OutlinedInput, MenuItem } from '@mui/material'
import { useReadMonitorsShortQuery } from 'services/monitor'

interface MarketSpySelectionSectionProps {
    marketSpyId?: number,
    onMarketSpyChange?: (event: any) => void
}

export const MarketSpySelectionSection = (props: MarketSpySelectionSectionProps): JSX.Element => {
    const {
        marketSpyId,
        onMarketSpyChange
    } = props

    const {
        data: readMonitorsShortQueryData,
        isLoading: readMonitorsShortQueryIsLoading,
        isFetching: readMonitorsShortQueryIsFetching
    } = useReadMonitorsShortQuery(undefined, undefined)

    const handleMarketSpiesChange = (event: any) => {
        onMarketSpyChange?.(event)
    }

    return (
        <div>
            <FormControl required sx={{ width: 350, mt: 2, '& *': { fontSize: '20px' } }}>
                <InputLabel id="MarketSpiesLabel">Market Spies</InputLabel>
                <Select
                    labelId="MarketSpiesLabel"
                    id="MarketSpiesLabelSelector"
                    value={marketSpyId ? marketSpyId?.toString() : ''}
                    onChange={handleMarketSpiesChange}
                    input={<OutlinedInput label="Market Spies" />}
                >
                    {
                        readMonitorsShortQueryData
                            ?.list
                            .filter((monitor: any) => monitor.mode !== 2)
                            .map((row: any) => {
                                return <MenuItem key={row.id} value={row.id}>{row.name}</MenuItem>
                            })
                    }
                </Select>
            </FormControl>
        </div>
    )
}